module.exports = __webpack_public_path__ + "img/工单.0bfcf783.svg";